import { render, staticRenderFns } from "./supplement.vue?vue&type=template&id=0b89a4c1&"
import script from "./supplement.vue?vue&type=script&lang=js&"
export * from "./supplement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports